module["exports"] = [
  "#####",
  "### ##",
  "## ###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/address/postcode.js
 ** module id = 938
 ** module chunks = 0
 **/